export default __webpack_public_path__ + "static/media/07.8c5ebb5b.jpg";